$(document).ready(function () {
    this.sidePanelShowHandler = function() {

        function addNewBatchPartRow(event, remainingQuantity = null) {
            const parentRow = $(event.target).closest('.batch-parts-row');
            const partId = $(event.target).closest('.batch-parts-row').data('part-id');
            const newPartsRow = parentRow.clone();

            // Increment the data-batch-number-row attribute
            const highestIndex = Math.max(...$(`.batch-parts-row[data-part-id="${partId}"]`).map(function() {
                return parseFloat($(this).attr('data-batch-number-row'));
            }).get());

            const newIndex = highestIndex + 1;
            newPartsRow.attr('data-batch-number-row', newIndex);

            // Update the names of the inputs to have the new index
            newPartsRow.find('input, textarea, select').each(function () {
                const name = $(this).attr('name');
                if (name) {
                    const newName = name.replace(/(\[parts\]\[\d+\]\[)\d+(\]\[\w+\])$/, `$1${newIndex}$2`);
                    $(this).attr('name', newName);

                    // Check if the newName contains the word 'part_id', if so skip it
                    if (!newName.includes('part_id')) {
                        $(this).val('');
                    }
                }
            });

            newPartsRow.find('.datepicker').datepicker({
                format: 'dd-mm-yyyy',
                autoclose: true,
                weekStart: 1,
            });

            newPartsRow.find('.add-new-parts-row').remove();
            newPartsRow.find('.remove-batch-number').remove();
            newPartsRow.find('.batch-parts-row-button').append('<button type="button" class="remove-batch-number btn btn-dark btn-sm ml-2"><i class="far fa-trash-alt"></i></button>');

            if (remainingQuantity !== null) {
                newPartsRow.find('td[data-column="quantity"] input').val(remainingQuantity);
                newPartsRow.attr('data-planned-quantity', remainingQuantity);
            }

            // Insert the new row after the parent row
            const parents = $(`.batch-parts-row[data-part-id="${partId}"]`);
            parents.last().after(newPartsRow);
        }

        function formatSelectedBatchQuantity(text) {
            const inside = text.match(/\(([^)]+)\)/)?.[1];
            return inside ? parseFloat(
                inside.replace(/\s/g, '')
                    .replace(/(?<=\d)[.,](?=\d{3}(?:\D|$))/g, '')
                    .replace(/,(\d{1,})$/, '.$1')
            ) : null;
        }

        function recalculateQuantities($partId) {
            const parentElements = $(`.batch-parts-row[data-part-id="${$partId}"]`);
            const initialQuantity = parseFloat(parentElements.first().find('td[data-column="quantity"]').data('planned-quantity'));
            let parentElementsCount = parentElements?.length || 0;
            let remainingQuantity = initialQuantity;

            if (parentElements.length === 1) {
                parentElements.last().find('td[data-column="quantity"] input').val(remainingQuantity);
                // Check if the batch number select is empty, if so, set the quantity to 0
                if (parentElements.last().find('td[data-column="batch_number"] select').val() === '') {
                    parentElements.closest('.batch-parts-row').find('.add-new-parts-row').prop('disabled', false);
                    parentElements.last().find('td[data-column="quantity"] input').val('');
                }

                const selectedOption = parentElements.last().find('td[data-column="batch_number"] option:selected');

                if (selectedOption.val() !== '') {
                    const value = formatSelectedBatchQuantity(
                        parentElements.last().find('td[data-column="batch_number"] option:selected').text()
                    );
                    // Attempt to parse the value to float, check if the value selected is equal or greater than the initial quantity. If so set the value of the input to the initial quantity, else reset the field
                    if (value >= initialQuantity) {
                        parentElements.last().find('td[data-column="quantity"] input').val(initialQuantity);
                        parentElements.closest('.batch-parts-row').find('.add-new-parts-row').prop('disabled', true);

                    } else {
                        parentElements.last().find('td[data-column="batch_number"] select').val('');
                        parentElements.closest('.batch-parts-row').find('.add-new-parts-row').prop('disabled', false);
                    }

                    return;
                }
            }

            parentElements.each(function() {
                const quantityInput = $(this).find('td[data-column="quantity"] input');
                const selectedBatch = $(this).find('td[data-column="batch_number"] option:selected');

                if (remainingQuantity <= 0) {
                    quantityInput.val('');
                    $(this).remove();
                    parentElementsCount--;
                    return;
                }

                if (selectedBatch.val() === '' && quantityInput.val() === '') {
                    quantityInput.val('');
                    return;
                }

                // Attempt to get selected quantity from the selected batch number
                const quantityMatch = selectedBatch.text().match(/\((\d+(\.\d+)?)\)/);
                let selectedQuantity = quantityMatch ? parseFloat(quantityMatch[1]) : 0;

                // If not empty and not a number, reset the value
                if(quantityInput.val() !== '') {
                    const value = parseFloat(quantityInput.val());
                    if (!isNaN(value)) {
                        selectedQuantity = value;
                    }
                }

                if (!isNaN(selectedQuantity)) {
                    const isNegative = remainingQuantity - selectedQuantity < 0;

                    if (isNegative) {
                        quantityInput.val(remainingQuantity);
                    }

                    remainingQuantity -= selectedQuantity;

                    if (quantityInput.val() === '') {
                        quantityInput.val(selectedQuantity);
                    }
                }
            });

            if (remainingQuantity <= 0 && parentElementsCount > 1) {
                parentElements.closest('.batch-parts-row').find('.add-new-parts-row').prop('disabled', true);
            } else {
                const lastEmptyInputRow = parentElements.filter(function() {
                    return $(this).find('td[data-column="quantity"] input').val() === '';
                }).first();

                if (lastEmptyInputRow.length) {
                    lastEmptyInputRow.find('td[data-column="quantity"] input').val(remainingQuantity);
                } else {
                    const newValue = parseFloat(parentElements.last().find('td[data-column="quantity"] input').val()) + remainingQuantity;
                    parentElements.last().find('td[data-column="quantity"] input').val(newValue);
                }

                parentElements.closest('.batch-parts-row').find('.add-new-parts-row').prop('disabled', false);
            }

            // Loop through selection items and disable the selected item
            setAvailableSelectionItems($partId);
        }

        function setAvailableSelectionItems($partId) {
            const parentElements = $(`.batch-parts-row[data-part-id="${$partId}"]`);
            const selectedValues = [];

            // Collect all selected values
            parentElements.find('.parts-row-batch-number-select').each(function() {
                const selectedValue = $(this).val();
                if (selectedValue) {
                    selectedValues.push(selectedValue);
                }
            });

            // Loop through all select elements and hide the selected options
            parentElements.find('.parts-row-batch-number-select').each(function() {
                const $select = $(this);
                $select.find('option').each(function() {
                    const $option = $(this);
                    if (selectedValues.includes($option.val()) && $option.val() !== $select.val()) {
                        $option.hide();
                    } else {
                        $option.show();
                    }
                });
            });
        }

        // Event listener for adding a new parts row
        $(document).on('click', '.add-new-parts-row', function (event) {
            addNewBatchPartRow(event);
        });

        // Event listener for removing a batch number row
        $(document).on('click', '.remove-batch-number', function() {
            const partId = $(this).closest('.batch-parts-row').data('part-id');
            $(this).closest('.batch-parts-row').remove();
            recalculateQuantities(partId);
        });

        $(document).on('blur', 'td[data-column="quantity"] input', function() {
            const $input = $(this);
            const newValue = parseFloat($input.val());
            const plannedQuantity = parseFloat($input.closest('td').data('planned-quantity'));
            const partId = $input.closest('.batch-parts-row').data('part-id');

            if (newValue < plannedQuantity) {
                const remainingQuantity = plannedQuantity - newValue;
                addNewBatchPartRow({ target: $input }, remainingQuantity);
                recalculateQuantities(partId);
            }
        });

        // Event listener for changes in parts-row-batch-number-select
        $(document).on('change', '.parts-row-batch-number-select', function() {
            const selectedValue = $(this).find('option:selected').val();
            const partId = $(this).closest('.batch-parts-row').data('part-id');

            if (selectedValue === '') {
                recalculateQuantities(partId);
                return;
            }

            const selectedBatchQuantity = formatSelectedBatchQuantity(
                $(this).find('option:selected').text()
            );

            const partRowQuantityTd = $(this).closest('tr').find('td[data-column="quantity"]');

            const requiredQuantityFromInput = parseFloat(partRowQuantityTd.find('input').val());

            // If the selected batch quantity is less than the required quantity from the input, set the quantity of the current row to the selected batch quantity
            if (selectedBatchQuantity < requiredQuantityFromInput) {
                // Set the quantity of the current row to the available quantity
                partRowQuantityTd.find('input').val(selectedBatchQuantity);

                // Calculate the remaining quantity
                const remainingQuantity = requiredQuantityFromInput - selectedBatchQuantity;

                // Check if there is a next row that has no selected value, if so, set the quantity to the remaining quantity
                const nextRow = $(this).closest('tr').nextAll(`.batch-parts-row[data-part-id="${partId}"]`).first();
                if (!nextRow.length || nextRow.find('.parts-row-batch-number-select').val()) {
                    // Create a new batch part row with the remaining quantity
                    addNewBatchPartRow({ target: this }, remainingQuantity);
                }
            }
            recalculateQuantities(partId);
        });

        // Event listener for adding a new parts row
        $('#finished_order_quantity').on('change', function (event) {
            const newValue = parseFloat($(this).val().replace(',', '.'));
            // Update inputs with batch-number-quantity class to new value
            $('.batch-number-quantity').val(newValue);
        });
    };

    this.sidePanelHideHandler = function() {
        location.reload();
    };

    $(document).on('nc.sidePanel.shown', this.sidePanelShowHandler);
    $(document).on('nc.sidePanel.hide', this.sidePanelHideHandler);
});
